const Graphics = () => {
  return (
    <svg width='19' height='18' viewBox='0 0 19 18' fill='none' xmlns='http://www.w3.org/2000/svg'>
      <path
        d='M13.5 13V8M9.5 13V5M5.5 13V11M3.5 17C2.39543 17 1.5 16.1046 1.5 15V3C1.5 1.89543 2.39543 1 3.5 1H15.5C16.6046 1 17.5 1.89543 17.5 3V15C17.5 16.1046 16.6046 17 15.5 17H3.5Z'
        stroke='#6B6B6B'
        strokeWidth='1.2'
        strokeLinecap='round'
        strokeLinejoin='round'
      />
    </svg>
  );
};

export default Graphics;
